import { SignupForm } from "@redotech/redo-model/signup-form";
import ImageIcon from "@redotech/redo-web/arbiter-icon/image-01.svg";
import { memo, ReactNode } from "react";
import {
  ButtonSize,
  RedoButtonCloseX,
} from "../arbiter-components/redo-button-close-x";
import { Flex } from "../flex";
import * as signupFormCss from "./signup-form.module.css";

export const SignupFormContainer = memo(function SignupFormContainer({
  form,
  children,
  onClose,
}: {
  form: SignupForm;
  children: ReactNode;
  onClose: () => void;
}) {
  const style = {
    backgroundColor: form.layout.backgroundColor,
    borderRadius: form.theme.border.cornerRadiusPx,
    border: form.theme.border.stroke.enabled
      ? `${form.theme.border.stroke.weightPx}px solid ${form.theme.border.stroke.color}`
      : "none",
    width: "600px",
  };
  const closeButtonStyle = {
    color: form.theme.closeButton.color,
    background: form.theme.closeButton.background.enabled
      ? form.theme.closeButton.background.color
      : "transparent",
  };

  const showImage = form.layout.image.style != "no";
  const backgroundImage = form.layout.image.style == "background";
  const vertical =
    form.layout.image.style === "top" || form.layout.image.style === "bottom";
  const imageFirst =
    form.layout.image.style === "top" || form.layout.image.style === "left";

  return (
    <Flex
      maxW="full"
      style={{
        ...style,
        backgroundImage: backgroundImage
          ? `url(${form.layout.image.url})`
          : "none",
        backgroundColor: "var(--redo-colors-gray-light-mode-300)",
      }}
      w="lg"
    >
      <Flex
        dir="column"
        gap="none"
        overflow="hidden"
        style={{
          ...style,
          margin: backgroundImage ? "50px" : "0px",
          background: form.layout.backgroundColor,
        }}
        w="full"
      >
        <Flex className={signupFormCss.closeButton} style={{ height: "0px" }}>
          <RedoButtonCloseX
            onclick={onClose}
            onDarkBackground={false}
            size={ButtonSize.SMALL}
            style={closeButtonStyle}
          />
        </Flex>
        <Flex
          dir={vertical ? "column" : "row"}
          gap="none"
          height="full"
          w="full"
        >
          {showImage && !backgroundImage && imageFirst && (
            <SignupImage url={form.layout.image.url} vertical={vertical} />
          )}
          <Flex
            align="stretch"
            className={signupFormCss.formContent}
            dir="column"
            flex={1}
            gap="none"
          >
            {children}
          </Flex>
          {showImage && !backgroundImage && !imageFirst && (
            <SignupImage url={form.layout.image.url} vertical={vertical} />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
});

const SignupImage = memo(function SignupImage({
  url,
  vertical,
}: {
  url: string;
  vertical: boolean;
}) {
  return (
    <Flex flex={1} style={{ maxHeight: vertical ? "216px" : "100%" }}>
      {url && <img className={signupFormCss.imageSection} src={url} />}

      {!url && (
        <Flex
          align="center"
          className={signupFormCss.imageSectionPlaceholder}
          dir="column"
          justify="center"
        >
          <ImageIcon />
          Add image
        </Flex>
      )}
    </Flex>
  );
});
